import {ReactNode} from 'react';

import {EmailCredentialsOwnerType, ListEmailCredentialsResponseBody} from '@dms/api/core';

import {useOpenOAuthCredentials} from '../hooks/useOpenOAuthCredentials';

interface OAuthCredentialsDialogProviderProps {
  children: ReactNode;
  credentials: ListEmailCredentialsResponseBody | undefined;
  ownerType: EmailCredentialsOwnerType;
}

export function OAuthCredentialsDialogProvider(props: OAuthCredentialsDialogProviderProps) {
  useOpenOAuthCredentials(props.credentials, props.ownerType);

  return props.children;
}
